import React, {useEffect, useState} from "react";
import {
    Input,
    Select,
    Button,
    Space,
    Card,
    Row,
    Col,
    message,
    Popconfirm,
    DatePicker
} from "antd";
import styles from "./InternalApplication.module.css";

import {Pagination} from 'antd';

import {
    getInternalInfoListRequest,
    getChannelRulerRequest
} from "../api";
import {closeAdminPage, openLogin} from "../../../../store/modalsSlice";
import settingIcon from "../setting.svg";
import {useDispatch} from "react-redux";
import InternalInfoItem from "./InternalInfoItem";
import dayjs from "dayjs";
import { clearAllCookies } from "../../../../util/handleObject";

const {Option} = Select;

const InternalApplication = (props) => {

    const dispatch = useDispatch();
    // 筛选表单状态
    const [filterForm, setFilterForm] = useState({
        name: "",
        rulerCode: "未选择",
        status: ""
    });
    const [infoList, setInfoList] = useState([]);
    const [channelList,setChannelList] = useState([{
        name: "未选择",
        channel: ""
    }]);
    const [rulerList,setRulerList] = useState([{
        name: "未选择",
        code: ""
    }]);
    const [rangeTime,setRangeTime]=useState(['','']);
    // 分页状态

    const [totalNumber, setTotalNumber] = useState(0);
    const [totalChengben, setTotalChengben] = useState(0);
    const [totalChengbenJifen, setTotalChengbenJifen] = useState(0);
    const [totalXiaohao, setTotalXiaohao] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [messageApi, contextHolder] = message.useMessage();
    const {RangePicker} = DatePicker;

    useEffect(() => {
        getChannelAndRuler()
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次
    function getChannelAndRuler() {
        getChannelRulerRequest((data) => {
            console.log(data);
            console.log(data);
            var newChannelList = [{
                name: "未选择",
                channel: ""
            }];
            var newRulerList = [{
                name: "未选择",
                code: ""
            }];
            if (data.ret == 1) {
                data.data.channel_list.forEach(element => {
                    newChannelList.push(element)
                });
                setChannelList(newChannelList)

                data.data.ruler_list.forEach(element => {
                    newRulerList.push(element)
                });
                setRulerList(newRulerList)
                getInfoList(filterForm.name, filterForm.rulerCode, filterForm.status, rangeTime, (currentPage - 1) * limit, limit,newRulerList,newChannelList)
            } else if (data.ret == 99) {
                messageApi.open({
                    type: 'warning',
                    // content: data.msg,
                    content: data.msg
                });
                setTimeout((e) => {
                    sessionStorage.clear()
                    clearAllCookies()
                    window.location.reload()
                }, 1000)
            }
            else {
                message.info(data.msg);
            }
        })
    }

    function getInfoList(namekey, rulerCode, channel, timeArray, offset, limit,rulerList1 = rulerList, channelList1 = channelList) {
        getInternalInfoListRequest(namekey, rulerCode == "未选择" ? "" : rulerCode, channel, timeArray, offset, limit, (data) => {
            console.log(data);
            if (data.ret === '1') {
                console.log(rulerList1);
                console.log('分割线-----222----')
                console.log(channelList1);
                let newList = data.data.data.map((item) => {
                    let rulerItemIndex = rulerList1.findIndex(element => element.code == item.jifei_guize)
                    let channelIndex = channelList1.findIndex(element => element.channel == item.channel)
                    return Object.assign(item, {
                        "jifei_guize_name":rulerItemIndex==-1?"": rulerList1[rulerItemIndex].name,
                        "channelName":channelIndex==-1?"": channelList1[channelIndex].name,
                    })
                })
                setInfoList(newList)
                setTotalNumber(data.data.total_num)
                setTotalChengben(data.data.chengben_total_num)
                setTotalChengbenJifen(data.data.chengben_jifen_total_num)
                setTotalXiaohao(data.data.xiaohao_total_num)
            } else {
                setInfoList([])
                setTotalNumber(0)
                setTotalChengben(0)
                setTotalChengbenJifen(0)
                setTotalXiaohao(0)
            }
        });
    }

    // 处理筛选表单变化
    const handleFilterChange = (name, value) => {
        setFilterForm({
            ...filterForm,
            [name]: value
        });
    };

    // 处理筛选提交
    const handleFilterSubmit = () => {
        setCurrentPage(1)
        getInfoList(filterForm.name, filterForm.rulerCode, filterForm.status, rangeTime, 0, limit)

    };

    // 处理重置筛选
    const handleResetFilter = () => {
        setFilterForm({
            name: "",
            rulerCode: "未选择",
            status: ""
        });
        setRangeTime(['',''])
        setCurrentPage(1)
        // 重置后重新获取所有数据
    };

    const onShowSizeChange = (page, pageSize) => {
        //pageSize 变化的回调
        console.log(page, pageSize);
        setCurrentPage(1)
        setLimit(pageSize)
    };

    const onChangePage = (current, pageSize) => {
        //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
        setCurrentPage(current)
        getInfoList(filterForm.name, filterForm.rulerCode, filterForm.status, rangeTime, (current - 1) * pageSize, pageSize)

    };


    const dateFormat = 'YYYY-MM-DD HH:mm';
    const today = new Date();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formatter = new Intl.DateTimeFormat('zh-CN', options);
    var maxDateString = formatter.format(today).replaceAll('/','-')+" 23:59";

    return (

        <div className={styles.background}>
            {contextHolder}
            <div className={styles.rightMenus}>
                <div className={styles["div-top"]}>
                    <h3 style={{marginLeft: 30}}>计费消耗管理</h3>

                    <Popconfirm
                        placement="bottom"
                        title={""}
                        description={"是否退出登录"}
                        okText="是"
                        cancelText="否"
                        onConfirm={(e) => {
                            sessionStorage.clear()
                            clearAllCookies()
                            dispatch(closeAdminPage())
                            dispatch(openLogin())
                        }}
                    >
                        <div className={styles.iconContainer}>
                            <img src={settingIcon} style={{width: '20px', height: '20px'}}/>
                        </div>
                    </Popconfirm>

                    <Button
                        className={styles["bt-refresh"]}
                        type="primary"
                        onClick={(e) => {
                            getInfoList(filterForm.name, filterForm.rulerCode, filterForm.status, rangeTime, (currentPage - 1) * limit, limit)
                        }}
                    >
                        刷新
                    </Button>
                </div>


                <Card
                    // tabList={tabList}
                    className={styles["card-top"]}
                    title={
                        <div className={styles.cardTab}>
                            <Button type='primary'
                                    style={{marginRight: "20px"}}
                                    onClick={() => {
                                        props.tabChange(0)
                                    }}
                            >内部应用</Button>
                            <Button color="default" variant="outlined"
                                    style={{marginLeft: "20px"}}
                                    onClick={() => {
                                        props.tabChange(1)
                                    }}
                            >外部应用</Button>
                            {/* <Button color="default" variant="outlined"
                                    style={{marginLeft: "20px"}}
                                    onClick={() => {
                                        props.tabChange(2)
                                    }}
                            >实验应用</Button> */}
                        </div>
                    }
                >


                    <div className={styles["div-shaixuan"]}>
                        <div>数据筛选</div>

                        <Space className={styles["bt-shaixuan2"]}>
                            <Button onClick={handleResetFilter}>重置</Button>
                            <Button
                                type="primary"
                                onClick={handleFilterSubmit}
                            >
                                查询
                            </Button>

                        </Space>

                    </div>
                    <Row gutter={[20,20]} align="middle" style={{marginTop: 20}}>
                        <Col
                        >
                            <Row align="middle">
                                <Col flex="50px"
                                >
                                    关键字
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                >
                                    <Input
                                        placeholder="关键字"
                                        value={filterForm.name}
                                        onChange={(e) => handleFilterChange("name", e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row align="middle">
                                <Col flex="60px"
                                >
                                    计费规则
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 60px)"}}
                                >
                                    <Select
                                        style={{marginLeft: "10px",minWidth:"90px"}}
                                        placeholder="计费规则"
                                        value={filterForm.rulerCode}
                                        onChange={(value) => handleFilterChange("rulerCode", value)}
                                    >
                                        {
                                            rulerList.map(item => {
                                                return <Option key={item.id}
                                                               value={item.code}>{item.name}</Option>
                                            })
                                        }
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row align="middle">
                                <Col flex="60px"
                                >
                                    应用来源
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 60px)"}}
                                    justify="start"
                                >
                                    <Select
                                        style={{marginLeft: "10px",minWidth:"90px"}}
                                        placeholder="应用来源"
                                        value={filterForm.status}
                                        onChange={(value) => handleFilterChange("status", value)}
                                    >
                                        {
                                            channelList.map(item => {
                                                return <Option key={item.id}
                                                               value={item.channel}>{item.name}</Option>
                                            })
                                        }
                                    </Select>
                                </Col>
                            </Row>
                        </Col>

                        <Col>
                            <Row align="middle">
                                <Col flex="60px"
                                >
                                    操作时间
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 60px)"}}
                                >
                                    <RangePicker
                                        // locale={locale}
                                        // needConfirm = {true}
                                        // minDate={dayjs('2024-01-01', dateFormat)}
                                        minDate={dayjs('2024-01-01 00:00', dateFormat)}
                                        maxDate={dayjs(maxDateString, dateFormat)}
                                        showTime={{format: 'HH:mm'}}
                                        value={rangeTime[0].length > 0 ? [dayjs(rangeTime[0], dateFormat), dayjs(rangeTime[1], dateFormat)] : null}
                                        onChange={(date, dateString) => {
                                            setRangeTime(dateString)
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>


                    </Row>
                </Card>

                <Card title="" className={styles["card-bottom"]}>
                    <div className={styles["container-list"]}>

                        <div className={styles["div-shaixuan"]}>
                            <div>数据列表</div>

                        </div>


                        <div className={styles.tableContainer}>
                            <table className={styles.infoTable}>
                                <tr
                                    className={styles.tr1}
                                >
                                    <td
                                        className={styles.td1}
                                    >应用名称
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >应用来源
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >计费规则
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >收费类型
                                    </td>
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>调用结果*/}
                                    {/*</td>*/}
                                    <td
                                        className={styles.td2}
                                    >成本消耗（第三方平台单位）
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >成本积分
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >用户消耗积分
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >账号
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >用户名
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >操作时间
                                    </td>
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>ip地址*/}
                                    {/*</td>*/}
                                </tr>
                                {infoList.map((item, index) => (
                                    <InternalInfoItem
                                        item={item}
                                        key={index + 1}
                                        index={index + 1}
                                    />
                                ))}
                            </table>

                            {/* 分页控件 - 右下角 */}

                        </div>
                        <div style={{display: "flex", alignItems:"center", justifyContent: "space-between"}}>
                            <div style={{display: "flex", alignItems:"center"}}>
                                <h3>成本消耗（第三方平台单位）:{totalChengben}</h3>
                                <h3 style={{marginLeft:20}}>成本积分:{totalChengbenJifen}</h3>
                                <h3 style={{marginLeft:20}}>用户消耗积分：{totalXiaohao}</h3>
                            </div>
                            <Pagination
                                hideOnSinglePage={false}//只有一页隐藏分页器
                                align="end"
                                style={{marginTop: 20,width:"50%"}}
                                showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                                onShowSizeChange={onShowSizeChange}//pageSize 变化的回调
                                defaultCurrent={1}
                                current={currentPage}
                                total={totalNumber}
                                locale={{
                                    items_per_page: '条/页',  // 将 "/page" 改为 "/页"
                                }}
                                pageSizeOptions={['10', '20', '30']} // 自定义选项值
                                pageSize={limit}
                                onChange={onChangePage}
                                showLessItems={false} // 关闭"简化显示"模式
                            />
                        </div>
                    </div>
                </Card>
            </div>

        </div>
    );
};

export default InternalApplication;

